import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  // selector: 'app-book-receipt-report',
  // standalone: true,
  // imports: [],
  templateUrl: './book-receipt-report.component.html',
  styleUrl: './book-receipt-report.component.scss'
})
export class BookReceiptReportComponent {
  filterData = [];
   startDate: string = '';
   currentDate= new Date();
  endDate: string = '';
  bookMonthwiseFormBeans: any = []
  // reportType = '';
  TotalBillAmt: number;
  TotalSelectedAmt: number;
  bookMonthwiseTotal: number = 0;
   reportType = '';
  // startDate: any;
  // endDate: any;
  constructor(
    private dialogRef: MatDialogRef<BookReceiptReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {
    console.log(this.data);
  }



  ngOnInit(): void {
    this.filterData = this.data['FilteredbookRcptRegisterdata'];
    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];

    this.calculateTotals();
    
  }
  

  calculateTotals(): void {
    this.TotalBillAmt = 0;
    this.TotalSelectedAmt = 0;

    for (let item of this.filterData) {
      this.TotalBillAmt += parseFloat(item.bill_amount) || 0;
      this.TotalSelectedAmt += parseFloat(item.select_entry_amt) || 0;

    }
  }

printPage(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=1400,height=900');
  if (!WindowPrt) return;

  WindowPrt.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <style>
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* ===== A4 LANDSCAPE ===== */
          @page {
            size: A4 landscape;
            margin: 8mm 6mm 8mm 10mm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 12px;
            color: #000;
            -webkit-font-smoothing: none;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000;
          }

          th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: middle;
            white-space: nowrap;
            text-align: left;
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          tfoot {
            display: table-row-group;
            font-weight: bold;
          }

          @media print {
            .noPrint { display: none !important; }
          }
        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt.document.close();
  WindowPrt.focus();

  setTimeout(() => {
    WindowPrt.print();
    WindowPrt.close();
  }, 500);
}






  exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);

    let element = document.getElementById('print-section');
    console.log('Element found:', element);

    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }

    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }


}
